// Hook usunięcia pozycji z kalkulacji oferty –
// DELETE /sales-crm/clients/:cid/offers/:oid/calculations/:calcId/positions/:id

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

type IResponse = ICommandResponseSuccess;

const deleteSalesCrmOfferCalculationPosition = (
  clientId: number,
  offerId: string,
  calculationId: number,
  positionId: number
): Promise<IResponse> =>
  axios.delete(
    `/sales-crm/clients/${clientId}/offers/${offerId}/calculations/${calculationId}/positions/${positionId}`
  );

export const useDeleteSalesCrmOfferCalculationPosition = (
  clientId: number,
  offerId: string,
  calculationId: number,
  options?: UseMutationOptions<IResponse, IError, number>
) =>
  useMutation(
    (positionId: number) =>
      deleteSalesCrmOfferCalculationPosition(clientId, offerId, calculationId, positionId),
    options
  );
